import { faImageSlash } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import clsx from 'clsx'
import { useConfig } from '~/domains/configuration/queries/config'
import { themeClass } from '~/styles/theme.css'
import type { AttachmentType } from '../../types'
import {
  attachmentPage,
  attachmentsGeneratingSubtitle,
  attachmentsGeneratingTitle,
  noAttachments,
  noAttachmentsIcon
} from '../AttachmentsViewer.css'

export const ImageViewer = ({ attachment }: { attachment: AttachmentType }) => {
  const { data: legacyUrl } = useConfig('organization.legacy_url')
  if (!attachment.url && !attachment.content) {
    return (
      <div className={clsx(noAttachments, themeClass)}>
        <div className={noAttachmentsIcon}>
          <FontAwesomeIcon icon={faImageSlash} />
        </div>
        <div className={attachmentsGeneratingTitle}>
          Erreur lors du chargement de l'image
        </div>
        <div className={attachmentsGeneratingSubtitle}>
          Le contenu de l'image n'est pas disponible.
        </div>
      </div>
    )
  }

  let url =
    attachment.url?.indexOf('/admin') !== -1
      ? `${legacyUrl}${attachment.url}`
      : attachment.url

  if (attachment.content) {
    url = `data:${attachment.mimeType};base64,${attachment.content}`
  }

  return (
    <div className={attachmentPage}>
      <img src={url} alt={attachment.name} style={{ maxWidth: '100%' }} />
    </div>
  )
}
